import styled, { keyframes } from 'styled-components/macro';
import { colorWhiteTransparent500 } from '@yme/tokens/colors';
import { Z_INDEX } from '@yme/tokens/zindex';
const SpinAnimation = keyframes `
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
export const SpinnerLoaderContainerStyled = styled.div `
  ${({ fullWidth }) => fullWidth && {
    position: 'relative',
}}
`;
export const SpinnerLoaderMaskStyled = styled.div `
  position: ${({ fullWidth }) => (fullWidth ? 'fixed' : 'absolute')};
  top: 0;
  left: 0;
  height: ${({ fullWidth }) => (fullWidth ? '100vh' : '100%')};
  width: ${({ fullWidth }) => (fullWidth ? '100vw' : '100%')};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${Z_INDEX.popupLevel3};
  ${({ hasBackground }) => hasBackground && `background-color: ${colorWhiteTransparent500}`};
`;
export const SpinnerLoaderStyled = styled.svg `
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  animation: ${SpinAnimation} 800ms linear infinite;
`;
